import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { EntryNotFoundException } from '@web/common';
import { isNil } from '@web/utils';
import { SelectItem } from '@web/shared/ui';
import { BoxQuestionnaireStatus } from '../enums';

@Injectable({
  providedIn: 'root',
})
export class BoxQuestionnaireStatusProviderService {
  private readonly entries = new Map<BoxQuestionnaireStatus, string>([
    [BoxQuestionnaireStatus.Pending, 'Oczekująca'],
    [BoxQuestionnaireStatus.Filled, 'Wypełniona'],
    [BoxQuestionnaireStatus.Ended, 'Zakończona'],
  ]);

  public labelFor(status: BoxQuestionnaireStatus): Observable<string> {
    const result = this.entries.get(status);

    if (isNil(result)) {
      throw new EntryNotFoundException(
        `The entry for "${status}" is not found.`,
      );
    }

    return of(result);
  }

  public selectItems(): Observable<SelectItem<BoxQuestionnaireStatus>[]> {
    return of(
      Array.from(this.entries.entries()).map(
        ([status, label]) =>
          new SelectItem<BoxQuestionnaireStatus>(label, status),
      ),
    );
  }
}
